import { BookedSlotGroup } from "./types.ts";

export type TeacherSlotStats = {
  assignedCount: number;
  candidateCount: number;
  /**
   * The teacher offered availability on this slot but did not get a class out
   * of it. Being a candidate implies having been available, so a slot the
   * teacher lost still counts as available. A slot counts at most once, no
   * matter how many classes he was a candidate for.
   */
  isAvailable: boolean;
};

export type TeacherSlotFilter = {
  teacherId: string;
  candidateClassRoomIds?: Set<string>;
};

export function getTeacherSlotStats(
  group: BookedSlotGroup,
  { teacherId, candidateClassRoomIds }: TeacherSlotFilter,
): TeacherSlotStats {
  const assignedCount = group.classRooms.filter(
    (c) => c.teacherId === teacherId,
  ).length;
  const candidateCount = group.classRooms.filter(
    (c) =>
      c.teacherId !== teacherId && candidateClassRoomIds?.has(c.classRoomId),
  ).length;
  const isAvailable =
    assignedCount === 0 &&
    (group.availableTeacherIds.includes(teacherId) || candidateCount > 0);

  return { assignedCount, candidateCount, isAvailable };
}
